<template>
  <div class="notice">
      <div class="notice_wrap pc_container">
        <div class="notice_title" v-if="false">
          <h1>通知公告</h1>
          <!-- <span class="more">查看更多</span> -->
        </div>
        <div class="notice_content">
          <div class="notice_left">
            <div class="date">
              <div class="day">{{notice.info.day}}</div>
              <div class="month">{{notice.info.year}}</div>
            </div>
            <div class="text" @click="detail(notice.info)" style="cursor: pointer">
              <div class="hd">{{notice.info.title}}</div>
              <div class="bd">{{notice.info.excerpt}}</div>
            </div>
          </div>
          <div class="notice_right">
            <div class="item" v-for="(item,index) in notice.list" :key="index" @click="detail(item)">
              <div> {{item.title}}</div>
              <div>{{item.created_at}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props:{
    notice: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
     
      first: {
        
      }
    }
  },
  computed: {},
  methods: {
    // 跳转详情
    detail(item) {
      console.log(item);
      
      this.$router.push({
        path:'/news/detail',
        query:{
          id:item.id,
          type: item.category.slug
        },
      })
    },
  },
  created() {
  },
}
</script>

<style lang="scss" scoped>
.notice {
  width: 100%;
  background: #2A59AB;
  .notice_wrap{
    color: #fff;
    padding:25px 0;
    .notice_title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      h1{
        font-size: 26px;
        color: #fff;
      }
      .more{
        font-size: 24px;
        color: #fff;
      }
    }
    .notice_content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      .notice_left{
        width: calc(1400px - 700px);
        height: 145px;
        display: flex;
        flex-direction: row;
        .date{
          display: flex;
          flex-direction: column;
          align-items: center;
          flex-shrink: 0;
          width: 134px;
          height:138px;
          background: #fff;
          margin-right: 39px;
          .day{
            font-size: 48px;
            color: #4D4D4D;
            line-height: 92px;
            height: 92px;
          }
          .month{
            font-size: 22px;
            color: #2A59AB;
            line-height: 46px;
            height: 46px;
            background: #ddd;
            width: 100%;
            text-align: center;
          }
        }
        .text{
          .hd{
            font-size: 22px;
          }
          .bd{
            font-size: 16px;
            line-height: 30px;
            margin-top: 10px;
            max-height: calc(30px * 3);
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }
      .notice_right{
        width: 680px;
        height: 145px;
        overflow: hidden;
        .item{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: 16px;
          color: #FDFAF0;
          line-height: 38px;
          cursor: pointer;
          >div:nth-child(1){
            width: calc(100% - 170px);
            height: 38px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          >div:last-child{
            color: #F3F3F3;
            width: 150px;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>